import { Content } from "./ContentResultList/ContentListItem/ContentListItem.types";

export enum SearchContentRequestStatusEnum {
    LOADING,
    ERROR,
    DEFAULT_DATA_LOADED,
    EMPTY_RESULTS_LOADED,
    RESULTS_LOADED,
}

export type SearchContentData = {
    contentList: Content[] | undefined;
    defaultList: Content[] | undefined;
    groupIds: number[];
    requestStatus: SearchContentRequestStatusEnum;
    searchValue: string;
};

export type SearchContentProps = {
    closeSearchModal: () => void;
    groupIds: number[];
};
